import React from 'react';
import commonCss from './css/SurveyStyle.scss'
import css from './css/StudentSurveyPropertiesStep.scss';
import Icon from 'SF/MaterialIcon';
import PropTypes from 'prop-types';
import {isNonEmptyString} from "utils/text";
import classnames from 'classnames';
import StudentSurveyPermissionsTable from './StudentSurveyPermissionsTable';
import {StudentSurveyPermission} from './types.js'
import {getWord} from 'utils/tenant';

function StudentSurveyPropertiesStep(props) {
    const validateTitleLength = () => {
        if (isNonEmptyString(props.title) && props.title.length >= 90) {
            return (
                <span className={css['comment-warning']} role='alert'>
                    <Icon icon='warning' aria-hidden='true' />You have reached the 90 character limit.
                </span>
            )
        }
    }

    const getTitleInput = () => <>
        <input id="titleText"
               className={css['input']}
               type="text"
               value={props.title}
               onChange={e => props.setProperties({ title: e.target.value })}
               autoFocus
               maxLength={90} />
        {validateTitleLength()}
    </>;

    const getReadOnlyTitleDisplay = () => (
        <div id="titleText" className={css['input']} aria-disabled>
            <span className={css['disabled-text']}>{props.title}</span>
            <Icon icon='lock' className={css['lock-icon']} aria-hidden />
        </div>
    );

    const studentSurvey = getWord('studentSurvey', false);

    return (
        <div>
            <h2 className={commonCss['header-second-level']}>Properties</h2>
            <div className={classnames(commonCss['instructional-text'], commonCss['spacing-below'])}>
                With the exception of the Title, the properties on this page can be modified at any time. Title will
                become read only after scheduling this {studentSurvey}.
            </div>
            <div className={classnames(commonCss['instructional-text'], commonCss['spacing-below'])}>
                <span className={commonCss['required-asterisk']}>*</span> Required Fields
            </div>
            <div className={commonCss['header-third-level']}>Title and Description</div>
            <div className={classnames(commonCss['instructional-text'], commonCss['spacing-below'])}>
                The Title can be up to 90 characters and displays to any role with permission to View the {studentSurvey}.
                The Description is only visible to Tenant Admins and can contain any details that help Tenant Admins
                differentiate this {studentSurvey}.
            </div>
            <div className={css['input-container']}>
                <label htmlFor="titleText"><span className={commonCss['required-asterisk']} aria-hidden>*</span>Title</label>
                {props.editable ? getTitleInput() : getReadOnlyTitleDisplay()}
            </div>
            <div className={css['input-container']}>
                <label htmlFor="surveyDescription">Description</label>
                <textarea id="surveyDescription"
                          value={props.surveyDescription || ''}
                          onChange={e => props.setProperties({ description: e.target.value })} />
            </div>
            <div>
                <h3 className={commonCss['header-third-level']}>Permissions</h3>
                <div className={classnames(commonCss['instructional-text'], commonCss['spacing-below'])}>
                    Select the roles that can view and/or edit the information gathered in this {studentSurvey}.
                    Only the Tenant Admin role can modify the {getWord('studentSurvey', false)} itself.
                </div>
                <div className={css['permissions-section']}>
                    <StudentSurveyPermissionsTable
                        roles={props.roles}
                        surveyPermissions={props.surveyPermissions}
                        setProperties={props.setProperties} />
                </div>
            </div>
        </div>
    )
}

StudentSurveyPropertiesStep.propTypes = {
    roles: PropTypes.arrayOf(Object),
    surveyPermissions: PropTypes.arrayOf(StudentSurveyPermission),
    title: PropTypes.string,
    surveyDescription: PropTypes.string,
    editable: PropTypes.bool.isRequired,
    setProperties: PropTypes.func.isRequired
}

export default StudentSurveyPropertiesStep;
